module.exports = __webpack_public_path__ + "img/notify1.2cbb092f.png";